// extracted by mini-css-extract-plugin
export default {"container":"body_container__LELpV"};